const productData = [
  {
    id: 1,
    name: "FOLD Short Edge Pull Handle",
    category: "Knobs & Handles",
    collection: "FOLD",
    sku: "COH-FOLD-070-2BK",
    price: "17.00",
    oldPrice: "33.00",
    discount: "48%",
    reviews: "10",
    rating: "5.0",
    image: "/img/101.jpg",
    images: ["/img/101.jpg", "/img/101a.jpg", "/img/101b.webp"],
    variants: [
      {
        type: "Mounting",
        options: ["Edge Mounted", "Front Mounted"],
      },
      {
        type: "Size",
        options: ["Short 70mm"],
      },
    ],
    colors: ["Black"],
    material: "Sheet metal / Stainless Steel",
    description: [
      "Self tapping wood screws included. Crafted from sheet metal, our FOLD Edge Pulls overhang cupboard or drawer tops for a minimalist look.",
    ],
    productInformation: {
      sku: "COH-FOLD-070-2BK",
      collection: "Shop the rest of the FOLD Collection",
      dimensions: "20 x 70 x 67 mm",
      ccSize: "50 mm",
      mechanicalWarranty: "10 years",
      finish: "Black",
      baseMaterial: "Stainless Steel",
      finishingProcess: "Electroplated",
      materialCharacteristics: "Low maintenance",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x Self-Tapping Wood Screws",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Minimalist edge pull design",
      "Self-tapping wood screws included",
      "Durable stainless steel construction",
      "Electroplated black finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 2,
    name: "FOLD Round Front Mounted Handle",
    category: "Knobs & Handles",
    collection: "FOLD",
    sku: "CFR-FOLD-070-1BR",
    price: "31.00",
    oldPrice: "61.00",
    discount: "49%",
    reviews: "10",
    rating: "5.0",
    image: "/img/102.webp",
    images: [
      "/img/102.webp",
      "/img/102a.webp",
      "/img/102b.jpg",
      "/img/102c.webp",
      "/img/102d.jpg",
      "/img/102e.webp",
    ],
    variants: [
      {
        type: "Mounting",
        options: ["Edge Mounted", "Front Mounted"],
      },
      {
        type: "Shape",
        options: ["Round"],
      },
    ],
    colors: ["Brass", "Aged Brass"],
    material: "Brass",
    description: [
      "15mm screws included. Crafted from sheet metal, our FOLD Front Mounted Pull makes a statement on kitchen cabinets or furniture pieces.",
    ],
    productInformation: {
      sku: "CFR-FOLD-070-1BR",
      collection: "Shop the rest of the FOLD Collection",
      dimensions: "60 x 70 x 27 mm",
      ccSize: "32 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x M4 Machine Screw(s)",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Statement front mounted design",
      "15mm machine screws included",
      "Solid brass construction",
      "Spray lacquer finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 3,
    name: "FOLD Round Front Mounted Handle",
    category: "Knobs & Handles",
    collection: "FOLD",
    sku: "CFR-FOLD-070-1AG",
    price: "31.00",
    oldPrice: "61.00",
    discount: "49%",
    reviews: "10",
    rating: "5.0",
    image: "/img/103.jpg",
    images: [
      "/img/103.jpg",
      "/img/103a.jpg",
      "/img/103b.jpg",
      "/img/103c.webp",
    ],
    variants: [
      {
        type: "Mounting",
        options: ["Edge Mounted", "Front Mounted"],
      },
      {
        type: "Size",
        options: ["Short 70mm"],
      },
    ],
    colors: ["Aged Brass"],
    material: "Brass",
    description: [
      "15mm screws included. Crafted from sheet metal, our FOLD Front Mounted Pull makes a statement on kitchen cabinets or furniture pieces.",
    ],
    productInformation: {
      sku: "CFR-FOLD-070-1AG",
      collection: "Shop the rest of the FOLD Collection",
      dimensions: "60 x 70 x 27 mm",
      ccSize: "32 mm",
      mechanicalWarranty: "10 years",
      finish: "Aged Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x M4 Machine Screw(s)",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Statement front mounted design",
      "15mm machine screws included",
      "Solid brass construction",
      "Spray lacquer finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 4,
    name: "FOLD Short D Shape Front Mounted Handle",
    category: "Knobs & Handles",
    collection: "FOLD",
    sku: "CFD-FOLD-070-1AG",
    price: "31.00",
    oldPrice: "61.00",
    discount: "49%",
    reviews: "10",
    rating: "5.0",
    image: "/img/104.jpg",
    images: [
      "/img/104.jpg",
      "/img/104a.jpg",
      "/img/104b.jpg",
      "/img/104c.webp",
    ],
    variants: [
      {
        type: "Mounting",
        options: ["Edge Mounted", "Front Mounted"],
      },
      {
        type: "Shape",
        options: ["Round", "Short 70mm"],
      },
    ],
    colors: ["Aged Brass"],
    material: "Brass",
    description: [
      "15mm screws included. Crafted from sheet metal, our FOLD Front Mounted Pull makes a statement on kitchen cabinets or furniture pieces.",
    ],
    productInformation: {
      sku: "CFD-FOLD-070-1AG",
      collection: "Shop the rest of the FOLD Collection",
      dimensions: "60 x 70 x 27 mm",
      ccSize: "32 mm",
      mechanicalWarranty: "10 years",
      finish: "Aged Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x M4 Machine Screw(s)",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "D shape front mounted design",
      "15mm machine screws included",
      "Solid brass construction",
      "Spray lacquer finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 5,
    name: "OLMO Round Recessed Pull Handle",
    category: "Knobs & Handles",
    collection: "OLMO",
    sku: "CRP-OLMO-055-1BK",
    price: "18.00",
    oldPrice: "36.00",
    discount: "50%",
    reviews: "12",
    rating: "5.0",
    image: "/img/105.webp",
    images: [
      "/img/105.webp",
      "/img/105a.webp",
      "/img/105b.jpg",
      "/img/105c.webp",
    ],
    variants: [
      {
        type: "Color",
        options: ["Black"],
      },
    ],
    colors: ["Black"],
    material: "Brass",
    description: [
      "Self tapping wood screws included. With its modern, recessed shape, OLMO creates a clean-lined, built-in look on cabinetry and wardrobes.",
    ],
    productInformation: {
      sku: "CRP-OLMO-055-1BK",
      collection: "Shop the rest of the OLMO Collection",
      dimensions: "35 x 55 x 14 mm",
      mechanicalWarranty: "10 years",
      finish: "Black",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x Self-Tapping Wood Screws",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Modern recessed design",
      "Self-tapping wood screws included",
      "Solid brass construction",
      "Spray lacquer black finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 6,
    name: "HOFFMAN 90mm Hook",
    category: "Hooks",
    collection: "HOFFMAN",
    sku: "ADH-HOFF-090-3BK-R",
    price: "20.00",
    oldPrice: "28.00",
    discount: "29%",
    reviews: "24",
    rating: "4.8",
    image: "/img/106.webp",
    images: [
      "/img/106.webp",
      "/img/106a.jpg",
      "/img/106b.jpg",
      "/img/106c.webp",
    ],
    variants: [
      {
        type: "Size",
        options: ["90mm", "150mm"],
      },
      {
        type: "Option",
        options: ["Single Hook", "Set of 5 Hooks"],
      },
    ],
    colors: ["Black", "Brass", "Antique Brass"],
    material: "Brass",
    description: [
      "M4 self tapping screws with wallplugs included. With a double-pronged design, our HOFFMAN Tapered Top Hook is ever-practical in hallways or bathrooms.",
    ],
    productInformation: {
      sku: "ADH-HOFF-090-3BK-R",
      collection: "Shop the rest of the HOFFMAN Collection",
      dimensions: "90 x 12 x 32 mm",
      maximumLoadWeight: "17kg",
      mechanicalWarranty: "10 years",
      finish: "Black",
      baseMaterial: "Brass",
      finishingProcess: "Electroplated",
      materialCharacteristics: "Added corrosion protection & durability",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "India",
      componentsIncluded: "2 x M4 Self Tapping Screw(s) with Wallplug(s)",
      toolsRequired: "Power Drill & Philips Screwdriver",
    },
    Features: [
      "Double-pronged design",
      "M4 screws and wallplugs included",
      "17kg maximum load weight",
      "Electroplated for corrosion protection",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 7,
    name: "BECKER Grooved D-Bar Handle",
    category: "Knobs & Handles",
    collection: "BECKER",
    sku: "KH-BECKER-170-BR",
    price: "72.00",
    oldPrice: "144.00",
    discount: "50%",
    reviews: "15",
    rating: "4.9",
    image: "/img/107.webp",
    images: [
      "/img/107.webp",
      "/img/107a.webp",
      "/img/107b.webp",
      "/img/107c.webp",
      "/img/107d.webp",
      "/img/107f.jpg",
    ],
    variants: [
      {
        type: "Type",
        options: ["Bezel", "Lennon", "T-Bar", "D-Bar", "Appliance"],
      },
      {
        type: "Length",
        options: ["170mm (160mm CC)", "230mm (220mm CC)", "682mm (672mm CC)"],
      },
      {
        type: "Option",
        options: ["Handle Only", "Handle with Round Backplate"],
      },
    ],
    colors: ["Brass", "Antique Brass"],
    material: "Brass",
    description: [
      "25mm screws included. With a square frame and grooved grip, BECKER has it all. Match with our LENNON Knob to complete any DIY home project.",
    ],
    productInformation: {
      sku: "KH-BECKER-170-BR",
      collection: "Shop the rest of the BECKER Collection",
      dimensions: "10 x 170 x 32 mm",
      ccSize: "160 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x 25mm M4 Machine Screws",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Square frame with grooved grip",
      "25mm M4 machine screws included",
      "Solid brass construction",
      "Spray lacquer brass finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 8,
    name: "GRAYSON Traditional Cup Pull",
    category: "Knobs & Handles",
    collection: "GRAYSON",
    sku: "CCP-GRAY-102-1AG",
    price: "36.00",
    oldPrice: "71.00",
    discount: "49%",
    reviews: "35",
    rating: "5.0",
    image: "/img/108.jpg",
    images: [
      "/img/108.jpg",
      "/img/108a.webp",
      "/img/108b.webp",
      "/img/108c.jpg",
      "/img/108d.webp",
      "/img/108e.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Knob", "Cup Pull", "Handle", "Appliance", "Hook"],
      },
      {
        type: "Length",
        options: ["102mm (76mm CC)", "155mm (128mm CC)"],
      },
    ],
    colors: [
      "Brass",
      "Aged Brass",
      "Antique Brass",
      "Polished Nickel",
      "Unlacquered Brass",
    ],
    material: "Brass",
    description: [
      "25mm screws included. A farmhouse-inspired cup pull, GRAYSON will add a timeless touch to your shaker style kitchen or any vintage furniture pieces.",
    ],
    productInformation: {
      sku: "CCP-GRAY-102-1AG",
      collection: "Shop the rest of the GRAYSON Collection",
      dimensions: "36 x 102.5 x 20.6 mm",
      ccSize: "76 mm",
      mechanicalWarranty: "10 years",
      finish: "Aged Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x 25mm M4 Machine Screws",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Traditional farmhouse cup pull design",
      "25mm M4 machine screws included",
      "Solid brass construction",
      "Spray lacquer aged brass finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 9,
    name: "KEPLER Heavyweight Appliance Pull",
    category: "Knobs & Handles",
    collection: "KEPLER",
    sku: "CTB-KEPL-512-1BR",
    price: "194.00",
    oldPrice: "388.00",
    discount: "50%",
    reviews: "351",
    rating: "5.0",
    image: "/img/109.jpg",
    images: [
      "/img/109.jpg",
      "/img/109a.webp",
      "/img/109b.webp",
      "/img/109c.jpg",
      "/img/109d.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Single T", "L-Bar", "T-Bar", "Appliance"],
      },
      {
        type: "Length",
        options: ["512mm (457mm CC)", "760mm (672mm CC)"],
      },
      {
        type: "Option",
        options: ["Handle Only", "Handle with Backplate"],
      },
    ],
    colors: ["Brass", "Antique Brass"],
    material: "Brass",
    description: [
      "25mm screws included. Striking and super-sized, our KEPLER Closet Bar adds a luxurious touch to kitchen larders or floor to ceiling wardrobes.",
    ],
    productInformation: {
      sku: "CTB-KEPL-512-1BR",
      collection: "Shop the rest of the KEPLER Collection",
      dimensions: "16 x 512 x 46 mm",
      ccSize: "457 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x 25mm M4 Machine Screws",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Super-sized striking design",
      "25mm M4 machine screws included",
      "Solid brass construction",
      "Spray lacquer brass finish",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 10,
    name: "LEVI Square Hook",
    category: "Hooks",
    collection: "LEVI",
    sku: "HK-LEVI-80-BK",
    price: "25.00",
    oldPrice: "36.00",
    discount: "31%",
    reviews: "9",
    rating: "5.0",
    image: "/img/1010.webp",
    images: [
      "/img/1010.webp",
      "/img/1010a.webp",
      "/img/1010b.jpg",
      "/img/1010c.webp",
    ],
    variants: [
      {
        type: "Option",
        options: ["Single Hook", "Set of 5 Hooks"],
      },
    ],
    colors: ["Black", "Brass", "Antique Brass"],
    material: "Brass",
    description: [
      "3mm self tapping screws included. Defined by a square shape, our large LEVI Hook can house two items at a time, whether in your hallway or bathroom.",
    ],
    productInformation: {
      sku: "HK-LEVI-80-BK",
      collection: "Shop the rest of the LEVI Collection",
      dimensions: "120 x 8 x 41 mm",
      maximumLoadWeight: "20kg",
      mechanicalWarranty: "10 years",
      finish: "Black",
      baseMaterial: "Brass",
      finishingProcess: "Electroplated",
      materialCharacteristics: "Added corrosion protection & durability",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x M4 Self Tapping Screw(s) with Wallplug(s)",
      toolsRequired: "Power Drill & Philips Screwdriver",
    },
    Features: [
      "Square modern design",
      "Holds two items at a time",
      "20kg maximum load weight",
      "Electroplated for corrosion protection",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 11,
    name: "BECKER Grooved Single T Handle",
    category: "Knobs & Handles",
    collection: "BECKER",
    sku: "CST-BECK-100-1BR",
    price: "36.00",
    oldPrice: "51.00",
    discount: "29%",
    reviews: "41",
    rating: "5.0",
    image: "/img/1011.webp",
    images: [
      "/img/1011.webp",
      "/img/1011a.webp",
      "/img/1011b.webp",
      "/img/1011c.webp",
      "/img/1011d.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Bezel", "Lennon", "T-Bar", "D-Bar", "Appliance"],
      },
    ],
    colors: ["Brass", "Antique Brass"],
    material: "Brass",
    description: [
      "25mm screws included. In a new large Single T handle format, BECKER's grooved grip will add texture to your cabinet doors and drawers.",
    ],
    productInformation: {
      sku: "CST-BECK-100-1BR",
      collection: "Shop the rest of the BECKER Collection",
      dimensions: "100 x 12 x 30 mm",
      ccSize: "12 mm",
      specialFeatures: "Double screw fixing for anti-spin",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded: "2 x 25mm M4 Machine Screws",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Single T handle format",
      "Grooved grip for added texture",
      "Double screw fixing for anti-spin",
      "Solid brass construction",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 12,
    name: "ERIN Flower Candlestick Holder",
    category: "Accessories",
    collection: "ERIN",
    sku: "ACH-FLOW-079-1BR",
    price: "27.00",
    oldPrice: "54.00",
    discount: "50%",
    reviews: "1",
    rating: "5.0",
    image: "/img/1012.webp",
    images: [
      "/img/1012.webp",
      "/img/1012a.webp",
      "/img/1012b.webp",
      "/img/1012c.webp",
      "/img/1012d.webp",
    ],
    variants: [
      {
        type: "Style",
        options: ["Flower", "Scallop"],
      },
    ],
    colors: ["Brass"],
    material: "Brass",
    description: [
      "Get tablescaping with our FLOWER Candlestick Holder as your statement centrepiece. It's the perfect gift for any home enthusiast.",
    ],
    productInformation: {
      sku: "ACH-FLOW-079-1BR",
      collection: "Shop the rest of the ERIN Collection",
      dimensions: "37 x 78.4 x 22 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      installation: "No installation required",
    },
    Features: [
      "Unique flower shape design",
      "Perfect for tablescaping",
      "Solid brass construction",
      "Spray lacquer finish",
      "Ideal gift for home enthusiasts",
    ],
  },
  {
    id: 13,
    name: "ELNA Metal Hook Backplate",
    category: "Hooks",
    collection: "ELNA",
    sku: "AHP-ELNA-575-3BK",
    price: "28.00",
    oldPrice: "56.00",
    discount: "50%",
    reviews: "1",
    rating: "5.0",
    image: "/img/1013.webp",
    images: ["/img/1013.webp", "/img/1013a.webp", "/img/1013b.webp"],
    variants: [
      {
        type: "Color",
        options: ["Black", "Brass"],
      },
    ],
    colors: ["Black", "Brass"],
    material: "Aluminium",
    description: [
      "M4 dowel screws with wallplugs included. Select five hooks to align on our ELNA Backplate, then install on your bedroom door or entryway wall.",
    ],
    productInformation: {
      sku: "AHP-ELNA-575-3BK",
      collection: "Shop the rest of the ELNA Collection",
      dimensions: "25 x 575 x 2 mm",
      specialFeatures:
        "Low-carbon option made from an ultra-lightweight aluminium that is fully recyclable.",
      mechanicalWarranty: "10 years",
      finish: "Black",
      baseMaterial: "Aluminium",
      materialCharacteristics: "Added corrosion protection & durability",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded:
        "3 x Dowel Screws, 3 Wall Plugs & 2 x M4 Screws (10mm Length)",
    },
    Features: [
      "Low-carbon ultra-lightweight aluminium",
      "Fully recyclable material",
      "Corrosion protection & durability",
      "10-year mechanical warranty",
      "M4 dowel screws and wallplugs included",
    ],
  },
  {
    id: 14,
    name: "FELIX Metal Wall Mounted Coat Rack",
    category: "Hooks",
    collection: "FELIX",
    sku: "KIT-AHP-FELI-575-1BR",
    price: "160.00",
    oldPrice: "198.00",
    discount: "19%",
    reviews: "5",
    rating: "5.0",
    image: "/img/1014.webp",
    images: [
      "/img/1014.webp",
      "/img/1014a.webp",
      "/img/1014b.webp",
      "/img/1014c.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Hook", "Coat Rack"],
      },
    ],
    colors: ["Brass"],
    material: "Brass",
    description: [
      "M4 dowel screws with wallplugs included. Proudly display five versatile hooks with our FELIX Backplate Set, to organise your home with style.",
    ],
    productInformation: {
      sku: "KIT-AHP-FELI-575-1BR",
      collection: "Shop the rest of the FELIX Collection",
      dimensions: "25 x 575 x 27 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      manufacturingCountry: "China",
    },
    Features: [
      "Set of five versatile hooks",
      "Stylish home organisation",
      "Solid brass construction",
      "10-year mechanical warranty",
      "M4 dowel screws and wallplugs included",
    ],
  },
  {
    id: 15,
    name: "ERIN Scallop Candlestick Holder",
    category: "Accessories",
    collection: "ERIN",
    sku: "ACH-SCAL-075-1BR",
    price: "27.00",
    oldPrice: "54.00",
    discount: "50%",
    reviews: "1",
    rating: "5.0",
    image: "/img/1015.webp",
    images: [
      "/img/1015.webp",
      "/img/1015a.webp",
      "/img/1015b.webp",
      "/img/1015c.webp",
      "/img/1015d.webp",
    ],
    variants: [
      {
        type: "Style",
        options: ["Flower", "Scallop"],
      },
    ],
    colors: ["Brass"],
    material: "Brass",
    description: [
      "Get tablescaping with our SCALLOP Candlestick Holder as your trend-led centrepiece. It's the perfect gift for any home enthusiast.",
    ],
    productInformation: {
      sku: "ACH-SCAL-075-1BR",
      collection: "Shop the rest of the ERIN Collection",
      dimensions: "37 x 74.47 x 22 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      finishingProcess: "Spray Lacquer",
      materialCharacteristics: "Material may age over time",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
    },
    Features: [
      "Trend-led scallop design",
      "Perfect statement centrepiece",
      "Solid brass construction",
      "10-year mechanical warranty",
      "Ideal for gifting",
    ],
  },
  {
    id: 16,
    name: "LENNON Metal Wall Mounted Coat Rack",
    category: "Hooks",
    collection: "BECKER",
    sku: "KIT-AHP-LENN-575-1BR",
    price: "201.00",
    oldPrice: "236.00",
    discount: "15%",
    reviews: "2",
    rating: "5.0",
    image: "/img/1016.webp",
    images: [
      "/img/1016.webp",
      "/img/1016a.webp",
      "/img/1016b.webp",
      "/img/1016c.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Hook", "Coat Rack"],
      },
    ],
    colors: ["Brass"],
    material: "Brass",
    description: [
      "M4 dowel screws with wallplugs included. Display five grooved hooks with our LENNON Backplate Set, to organise your hallway or bathroom with style.",
    ],
    productInformation: {
      sku: "KIT-AHP-LENN-575-1BR",
      collection: "Shop the rest of the BECKER Collection",
      dimensions: "25 x 575 x 34 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      manufacturingCountry: "China",
      componentsIncluded:
        "3 x Dowel Screws, 3 Wall Plugs & 2 x M4 Screws (10mm Length)",
    },
    Features: [
      "Five grooved hooks set",
      "Stylish organisation solution",
      "Solid brass construction",
      "10-year mechanical warranty",
      "Complete mounting hardware included",
    ],
  },
  {
    id: 17,
    name: "ELNA Metal Hook Backplate",
    category: "Hooks",
    collection: "ELNA",
    sku: "AHP-ELNA-575-1BR",
    price: "36.00",
    oldPrice: "72.00",
    discount: "50%",
    reviews: "1",
    rating: "5.0",
    image: "/img/1017.webp",
    images: ["/img/1017.webp", "/img/1017a.webp"],
    variants: [
      {
        type: "Color",
        options: ["Brass", "Black"],
      },
    ],
    colors: ["Brass", "Black"],
    material: "Brass",
    description: [
      "M4 dowel screws with wallplugs included. Select five hooks to align on our ELNA Backplate, then install on your bedroom door or entryway wall.",
    ],
    productInformation: {
      sku: "AHP-ELNA-575-1BR",
      collection: "Shop the rest of the ELNA Collection",
      dimensions: "25 x 575 x 2 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      materialCharacteristics: "Added corrosion protection & durability",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "China",
      componentsIncluded:
        "3 x Dowel Screws, 3 Wall Plugs & 2 x M4 Screws (10mm Length)",
    },
    Features: [
      "M4 dowel screws and wallplugs included",
      "Align five hooks on backplate",
      "Solid brass construction",
      "Corrosion protection & durability",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 18,
    name: "REVILL Metal Wall Mounted Coat Rack",
    category: "Hooks",
    collection: "KEPLER",
    sku: "KIT-AHP-REVI-575-1BR",
    price: "201.00",
    oldPrice: "236.00",
    discount: "15%",
    reviews: "2",
    rating: "5.0",
    image: "/img/1018.jpg",
    images: [
      "/img/1018.jpg",
      "/img/1018a.webp",
      "/img/1018b.webp",
      "/img/1018c.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Hook", "Coat Rack"],
      },
    ],
    colors: ["Brass"],
    material: "Brass",
    description: [
      "M4 dowel screws with wallplugs included. Display five intricately knurled hooks with our REVILL Backplate Set, to organise your hallway with style.",
    ],
    productInformation: {
      sku: "KIT-AHP-REVI-575-1BR",
      collection: "Shop the rest of the KEPLER Collection",
      dimensions: "25 x 575 x 34 mm",
      mechanicalWarranty: "10 years",
      finish: "Brass",
      baseMaterial: "Brass",
      manufacturingCountry: "China",
    },
    Features: [
      "Five intricately knurled hooks set",
      "Stylish organisation solution",
      "Solid brass construction",
      "10-year mechanical warranty",
      "Complete mounting hardware included",
    ],
  },
  {
    id: 19,
    name: "LENA Decorative Tassel",
    category: "Accessories",
    collection: "LENA",
    sku: "AXM-LENA-100-10LB",
    price: "11.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/1019.webp",
    images: ["/img/1019.webp", "/img/1019a.webp", "/img/1019b.webp"],
    variants: [
      {
        type: "Color",
        options: ["Light Blue", "Burgundy", "Ochre"],
      },
    ],
    colors: ["Light Blue", "Burgundy", "Ochre"],
    material: "Fabric",
    description: [
      "Hand-finished with a soft, tactile drape, LENA adds a playful, decorative touch to cabinetry, wardrobes, and furniture knobs.",
    ],
    productInformation: {
      sku: "AXM-LENA-100-10LB",
      specialFeatures:
        "Decorative tassel for cabinet knobs and drawer pulls - adds texture, colour and a tactile finish to plain hardware",
      mechanicalWarranty: "10 years",
      finish: "Burgundy, Light Blue, Ochre",
      manufacturingCountry: "India",
    },
    Features: [
      "Hand-finished soft tactile drape",
      "Playful decorative touch",
      "Adds texture and color",
      "10-year mechanical warranty",
      "Ideal for cabinet knobs and drawer pulls",
    ],
  },
  {
    id: 20,
    name: "PEYTON Heavyweight Handle",
    category: "Knobs & Handles",
    collection: "PEYTON",
    sku: "CDB-PEYT-479-1HB",
    price: "331.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/1020.webp",
    images: ["/img/1020.webp", "/img/1020a.webp", "/img/1020b.webp"],
    variants: [
      {
        type: "Type",
        options: ["Knob", "Handle", "Appliance"],
      },
      {
        type: "Color",
        options: [
          "Heirloom Brass",
          "Blackened Bronze",
          "Unlacquered Brass",
          "Polished Nickel",
        ],
      },
      {
        type: "Length",
        options: ["479mm (457mm CC)"],
      },
    ],
    colors: [
      "Heirloom Brass",
      "Blackened Bronze",
      "Unlacquered Brass",
      "Polished Nickel",
    ],
    material: "Brass",
    description: [
      "25mm screws included. Crafted from solid brass with a Heavyweight D-bar profile in a bold 479mm length, PEYTON brings timeless elegance to kitchen and wardrobe cabinetry.",
    ],
    productInformation: {
      sku: "CDB-PEYT-479-1HB",
      collection: "Shop the rest of the PEYTON Collection",
      dimensions: "42 x 21 x 479 mm",
      ccSize: "457 mm",
      mechanicalWarranty: "10 years",
      finish: "Heirloom Brass",
      baseMaterial: "Brass",
      finishingProcess: "Hand Finished & Spray Lacquer",
      materialCharacteristics:
        "Hand finished process - colour may slightly vary in tone",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "India",
      componentsIncluded: "2 x 25mm M4 Machine Screws",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Solid brass construction",
      "Heavyweight D-bar profile",
      "Bold 479mm length",
      "Hand-finished process",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 21,
    name: "ESBEN Single T Handle",
    category: "Knobs & Handles",
    collection: "ESBEN",
    sku: "CST-ESBE-074-1PNB",
    price: "44.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/1021.webp",
    images: [
      "/img/1021.webp",
      "/img/1021a.webp",
      "/img/1021b.webp",
      "/img/1021c.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Single T", "Handle", "Appliance"],
      },
      {
        type: "Color",
        options: [
          "Polished Nickel & Unlacquered Brass",
          "Blackened Bronze",
          "Unlacquered Brass",
          "Polished Nickel",
        ],
      },
    ],
    colors: [
      "Polished Nickel & Unlacquered Brass",
      "Blackened Bronze",
      "Unlacquered Brass",
      "Polished Nickel",
    ],
    material: "Brass",
    description: [
      "25mm screw included. ESBEN's architectural T-bar design in solid brass creates a bold statement for cabinetry and furniture, bringing a contemporary edge to any interior.",
    ],
    productInformation: {
      sku: "CST-ESBE-074-1PNB",
      collection: "Shop the rest of the ESBEN Collection",
      dimensions: "44 x 21 x 74 mm",
      mechanicalWarranty: "10 years",
      finish: "Polished Nickel & Unlacquered Brass",
      baseMaterial: "Brass",
      finishingProcess: "Polished",
      materialCharacteristics:
        "Hand finished process - colour may slightly vary in tone",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "India",
      componentsIncluded: "1 x 25mm M4 Machine Screw",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Architectural T-bar design",
      "Solid brass construction",
      "Bold contemporary edge",
      "Hand-finished polished process",
      "10-year mechanical warranty",
    ],
  },
  {
    id: 22,
    name: "PEYTON Oval Knob",
    category: "Knobs & Handles",
    collection: "PEYTON",
    sku: "CKN-PEYT-039-1BB",
    price: "31.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/1022.webp",
    images: [
      "/img/1022.webp",
      "/img/1022a.webp",
      "/img/1022b.webp",
      "/img/1022c.webp",
      "/img/1022d.webp",
    ],
    variants: [
      {
        type: "Type",
        options: ["Knob", "Handle", "Appliance"],
      },
      {
        type: "Color",
        options: [
          "Blackened Bronze",
          "Heirloom Brass",
          "Unlacquered Brass",
          "Polished Nickel",
        ],
      },
    ],
    colors: [
      "Blackened Bronze",
      "Heirloom Brass",
      "Unlacquered Brass",
      "Polished Nickel",
    ],
    material: "Brass",
    description: [
      "25mm screw included. Crafted from solid brass with a classic shaker form, PEYTON adds a refined, traditional touch to kitchen cabinetry, wardrobes, and furniture.",
    ],
    productInformation: {
      sku: "CKN-PEYT-039-1BB",
      collection: "Shop the rest of the PEYTON Collection",
      dimensions: "33 x 20 x 39 mm",
      mechanicalWarranty: "10 years",
      finish: "Blackened Bronze",
      baseMaterial: "Brass",
      finishingProcess: "Chemical Blackening & Wax",
      materialCharacteristics:
        "Hand finished process - colour may slightly vary in tone",
      productCare:
        "Wash with warm water and soap. Avoid abrasive cleaning solutions.",
      manufacturingCountry: "India",
      componentsIncluded: "1 x 25mm M4 Machine Screw",
      toolsRequired: "Philips Screwdriver",
    },
    Features: [
      "Classic shaker form",
      "Solid brass construction",
      "Refined traditional touch",
      "Hand-finished chemical blackening & wax",
      "10-year mechanical warranty",
    ],
  },
];

export default productData;
